import React, {
    useEffect, useRef, useState,
} from 'react';
import format from 'date-fns/format';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useParams, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import DialogContentText from '@material-ui/core/DialogContentText';
import _ from 'lodash';
import ReactPlayer from 'react-player';
import { Box } from '@material-ui/core';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import WrapperContainer from '../../components/Container/WrapperContainer';
import CustomTypography from '../../components/Typography/CustomTypography';
import AlertDialog from '../../components/Dialog/AlertDialog';
import Snackbar from '../../components/Snackbar/Snackbar';
import Button from '../../components/Button/CustomButton';
import DetailSeminarStyle from '../../assets/jss/pages/detailSeminarCompanyStyle';
import Loader from '../../components/Loader/Loader';
import ViewHeader from '../../components/Header/ViewHeader';
import { MEDIA_TYPE } from '../../common/Constants';
import API from '../../common/API';
import SeminarPayment from './SeminarPayment';
import ConfirmDialog from '../../components/Dialog/ConfirmDialog';

const useStyles = makeStyles(DetailSeminarStyle);

export const Header = (props) => {
    const { eventInfo, customText } = props;
    const intl = useIntl();
    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <ViewHeader
                    eventName={eventInfo.name}
                    title={customText?.screen_name?.seminar_details || intl.formatMessage({ id: 'userRouters.seminarDetail' })}
                    isIntl={false}
                    eventInfo={eventInfo}
                />
            )}
        </>
    );
};

Header.defaultProps = {
    eventInfo: {},
    customText: {},
};

Header.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
};
const DetailSeminar = (props) => {
    const {
        getDetailSeminarViewer,
        clearDetailSeminarViewer,
        registerSeminarRequested,
        clearRegisterSeminar,
        detailSeminarViewer,
        registerStatus,
        idRegister,
        isLoading,
        paymentLink,
        eventInfo,
        getDetailSeminarFreeLogin,
        detailSeminarRegistered,
        clearRegisteredSeminar,
        registerErrors,
        token,
        isAuthorized,
        isWeakAuth,
        customText,
        customColor,
        locale,
    } = props;
    const classes = useStyles(props);
    const [params, setParams] = useState({});
    const history = useHistory();
    const intl = useIntl();
    const routeParams = useParams();
    const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState({ open: false, content: '' });
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });
    const [openDialogDetail, setOpenDialogDetail] = useState(false);
    const [isOpenConfirmSuccess, setIsOpenConfirmSuccess] = useState({ open: false, content: '', success: false });

    useEffect(() => () => {
        clearDetailSeminarViewer();
        clearRegisteredSeminar();
        clearRegisterSeminar();
    }, []);

    useEffect(() => {
        if (!_.isEmpty(eventInfo) && !_.isEmpty(detailSeminarViewer)) {
            if (isAuthorized && isWeakAuth === '' && !eventInfo.free_seminar) {
                setParams(detailSeminarViewer);
            }
        }
    }, [detailSeminarViewer, eventInfo, isWeakAuth, isAuthorized]);

    useEffect(() => {
        if (!_.isEmpty(eventInfo) && !_.isEmpty(detailSeminarRegistered)) {
            if (eventInfo.free_seminar && isAuthorized) {
                setParams(detailSeminarRegistered);
            }
        }
    }, [detailSeminarRegistered, eventInfo, isAuthorized, isWeakAuth]);

    useEffect(() => {
        if (!_.isEmpty(eventInfo)) {
            if (eventInfo.free_seminar && isAuthorized) {
                getDetailSeminarFreeLogin({
                    event_name: routeParams.shortName,
                    seminar_id: routeParams.id,
                    language: locale,
                });

                API.get({
                    endpoint: `/api/v1/seminar/${routeParams.id}/mark_as_read/`,
                    body: {},
                    token,
                });
            } else {
                getDetailSeminarViewer({
                    event_name: routeParams.shortName,
                    seminar_id: routeParams.id,
                    language: locale,
                });
            }
        }
    }, [routeParams, eventInfo, locale]);

    useEffect(() => {
        if (!_.isEmpty(idRegister)) {
            if (registerStatus === false) {
                setSnackbar({
                    isOpen: true,
                    type: 'error',
                    message: intl.formatMessage({ id: 'seminar.errorRegister' }, {
                        namePage: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list
                        || intl.formatMessage({ id: 'login.seminars' }).toLocaleLowerCase(),
                    }),
                });
                clearRegisterSeminar();
            }
            if (registerStatus && !params.cost) {
                setIsOpenConfirmSuccess({ open: true, content: intl.formatMessage({ id: 'common.completeApplication' }), success: true });
            } else if (registerStatus && params.payment_method && params.cost) {
                handleCloseDialogDetail();
                if (+params.payment_method === 1) {
                    setIsOpenConfirmSuccess({
                        open: true,
                        content: intl.formatMessage({ id: 'common.completeApplication' }),
                        success: true,
                    });
                } else if (+params.payment_method === 2) {
                    setIsOpenConfirmSuccess({
                        open: true,
                        content: getContent(),
                        success: true,
                    });
                }
            }
        }
    }, [idRegister]);

    const getContent = () => (
        <>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>{intl.formatMessage({ id: 'common.completeApplication' })}</DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>{intl.formatMessage({ id: 'common.emailBillDetail' })}</DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>{intl.formatMessage({ id: 'common.confirm' })}</DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>{intl.formatMessage({ id: 'common.sendMoney' })}</DialogContentText>
        </>
    );

    useEffect(() => {
        if (!_.isEmpty(registerErrors) && registerErrors.code === 'BAD_REQUEST') {
            const { message } = registerErrors?.message;
            setIsOpenConfirmSuccess({
                open: true,
                content: message,
                success: false,
            });
            clearRegisterSeminar();
            handleCloseConfirmDialog();
        }
    }, [registerErrors]);

    const handleSuccessDialog = () => {
        if (!isOpenConfirmSuccess.success) {
            setIsOpenConfirmSuccess({ open: false, content: '', success: false });
        } else {
            const { shortName } = routeParams;
            history.push(`/${shortName}/seminar_registered`);
        }
    };

    const checkIsValidSeminar = (date, stime, etime) => {
        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
        const timeRunningStart = new Date(`${date} , ${stime}`);
        const timeRunningEnd = new Date(`${date} , ${etime}`);
        const isActiveBeforeStart = utcDateNow <= new Date(timeRunningStart.setDate(timeRunningStart.getDate() - 30));
        const isActiveAfterEnd = utcDateNow >= new Date(timeRunningEnd.setDate(timeRunningEnd.getDate() + 30));
        const seminarDisable = isActiveBeforeStart || isActiveAfterEnd;

        return seminarDisable;
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };
    const handleDialogRegisterSeminar = () => {
        if (!params.cost) {
            setIsOpenConfirmDialog({ open: false, content: '' });
            handleRegisterSeminar();
        } else if (params.cost) {
            setOpenDialogDetail(true);
            setIsOpenConfirmDialog({ open: false, content: '' });
        }
    };

    const handleRegisterSeminar = () => {
        let dataSubmit;
        if (!params.cost) {
            dataSubmit = {
                seminar_ids: [params.id],
            };
            registerSeminarRequested({ data: dataSubmit, language: locale });
        }
    };

    const handleCloseDialogDetail = () => {
        setOpenDialogDetail(false);
    };

    const handleShowConfirmDialog = () => {
        setIsOpenConfirmDialog({
            open: true,
            content: eventInfo?.settings_texts_sidebar_viewer?.field_name?.seminar_list
                ? intl.formatMessage({ id: 'seminar.register' }) : intl.formatMessage({ id: 'seminar.registerSeminar' }, {
                    name: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list
                    || intl.formatMessage({ id: 'login.seminars' }).toLocaleLowerCase(),
                }),
        });
    };
    const handleCloseConfirmDialog = () => {
        setIsOpenConfirmDialog({ open: false, content: '' });
    };

    const isSeminarViewable = (dataDateTime, paused) => {
        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
        const timeRunningStart = new Date(`${dataDateTime.date} , ${dataDateTime.stime}`);
        const timeRunningEnd = new Date(`${dataDateTime.date} , ${dataDateTime.etime}`);
        const dateBeforeSeminarView = utcDateNow < new Date(timeRunningStart.setDate(timeRunningStart.getDate()));
        const seminarActiveAfter = utcDateNow >= new Date(timeRunningEnd.setDate(timeRunningEnd.getDate() + 30));

        return !paused && !dateBeforeSeminarView && !seminarActiveAfter;
    };

    const renderButton = (title, href, target) => (
        <Button
            color="navy"
            gradient
            size="sm"
            round
            className={classes.btnStyle}
            href={href}
            target={target}
            buttonTextColor={customColor?.button_text_color}
            buttonBackgroundColor={customColor?.button_background_color?.common_button}
        >
            {title}
        </Button>
    );

    return (
        <>
            <Loader isLoading={isLoading} />
            {!_.isEmpty(eventInfo) && (
                <WrapperContainer xs={12} md={12} className={classes.wrapper}>
                    <GridItem md={12} className={classes.leftContent}>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.seminar_time || intl.formatMessage({ id: 'seminar.period' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {params.date && format(new Date(params.date), 'yyyy/MM/dd')}
                                    &#160;
                                    &#160;
                                    {' '}
                                    {params.stime}
                                    {' '}
                                    ~
                                    {' '}
                                    {params.etime}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.lecture_name || intl.formatMessage({ id: 'seminar.lectureName' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {params.title}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.speaker || intl.formatMessage({ id: 'seminar.speaker' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {params.speaker}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.speaker_photo || intl.formatMessage({ id: 'seminar.speakerPhoto' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    <img src={params.speaker_img} alt="" style={{ borderRadius: '10px', maxWidth: '100%', maxHeight: '200px' }} />
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        {locale === 'ja' && (
                            <GridContainer className={classes.spacingViewer}>
                                <GridItem xs={12} sm={3} md={3}>
                                    <CustomTypography bold customColor={customColor?.contents_text_color}>
                                        {customText?.field_name?.speaker_profile || intl.formatMessage({ id: 'seminar.speakerProfile' })}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={9} md={9}>
                                    <CustomTypography customColor={customColor?.contents_text_color}>
                                        {params.speaker_profile}
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>
                        )}
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.lecture_content || intl.formatMessage({ id: 'seminar.lectureContent' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {params.content}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.maximum_applicants || intl.formatMessage({ id: 'seminar.maxApplicant' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                {
                                    !(params.limit === -1) ? (
                                        <CustomTypography customColor={customColor?.contents_text_color}>
                                            {params.limit}
                                            {' '}
                                            {intl.formatMessage({ id: 'common.people' }).toLocaleLowerCase()}
                                        </CustomTypography>
                                    ) : (
                                        <CustomTypography customColor={customColor?.contents_text_color}>
                                            {intl.formatMessage({ id: 'noLimit' })}
                                        </CustomTypography>
                                    )
                                }
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.price || intl.formatMessage({ id: 'price' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {params.cost > 0
                                        ? `${intl.formatNumber(params.cost)}${intl.formatMessage({ id: 'common.yen' })}`
                                        : intl.formatMessage({ id: 'common.free' })}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        {
                            isAuthorized && isWeakAuth === '' && !eventInfo.free_seminar && (
                                <GridItem xs={12} style={{ textAlign: 'center', marginTop: '40px', zIndex: 1 }}>
                                    <Button
                                        disabled={params.is_registered || checkIsValidSeminar(params.date, params.stime, params.etime)}
                                        color="navy"
                                        round
                                        gradient
                                        size="md"
                                        onClick={() => handleShowConfirmDialog()}
                                        buttonTextColor={customColor?.button_text_color}
                                        buttonBackgroundColor={customColor?.button_background_color?.common_button}
                                    >
                                        <b>{customText?.button_name?.seminar_application || intl.formatMessage({ id: 'registerViewer.applicationSeminar' })}</b>
                                    </Button>
                                </GridItem>
                            )
                        }
                        {
                            eventInfo.free_seminar
                                && isSeminarViewable({ date: params.date, stime: params.stime, etime: params.etime }, params.is_paused) && (
                                (
                                    <>
                                        <GridItem
                                            xs={12}
                                            style={{
                                                textAlign: 'center',
                                                marginTop: '40px',
                                                marginBottom: '20px',
                                                zIndex: 1,
                                            }}
                                        >
                                            <ReactPlayer
                                                controls
                                                config={{
                                                    attributes: {
                                                        controlsList: 'nodownload',
                                                        style: {
                                                            outline: 'none',
                                                            margin: 'auto',
                                                            maxHeight: '100%',
                                                            width: '100%',
                                                        },
                                                    },
                                                    forceAudio: params.media_type === MEDIA_TYPE.AUDIO,
                                                }}
                                                height={params.media_type === MEDIA_TYPE.AUDIO ? 60 : 550}
                                                width="100%"
                                                url={params.media && `${params.media}?token=${token}`}
                                                style={{ display: 'flex' }}
                                            />
                                        </GridItem>

                                        <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                                            { params.document_link && renderButton(
                                                customText?.button_name?.document_link || intl.formatMessage({ id: 'productRegister.documentRequestReception' }),
                                                params.document_link,
                                                '_blank',
                                            )}
                                            { params.document && renderButton(
                                                customText?.button_name?.document || intl.formatMessage({ id: 'exhibition.documentDownload' }),
                                                params.document,
                                                '_blank',
                                            )}
                                            { params.link_contact
                                                && renderButton(
                                                    customText?.button_name?.link_contact || intl.formatMessage({ id: 'organizerBusinessContact.inquiries' }),
                                                    `https://mail.google.com/mail/?view=cm&fs=1&to=${params.link_contact}`,
                                                    '_blank',
                                                )}
                                            { params.survey_link && renderButton(
                                                customText?.button_name?.survey_link || intl.formatMessage({ id: 'productRegister.survey' }),
                                                params.survey_link,
                                                '_blank',
                                            )}
                                        </Box>
                                    </>
                                )
                            )
                        }
                        <SeminarPayment
                            isOpen={openDialogDetail}
                            handleClose={handleCloseDialogDetail}
                            registerCheck={{ [params.id]: { [params.id]: params.id, price: params.cost, titleSeminar: params.title } }}
                            getRegisterCost={params.cost}
                            eventInfo={eventInfo}
                            registerSeminar={registerSeminarRequested}
                            getTokenError={(value) => setIsOpenConfirmSuccess({ open: true, content: value, success: false })}
                            payment={(value) => setParams({ ...params, payment_method: value })}
                            customText={customText}
                            customColor={customColor}
                            locale={locale}
                        />
                        <Snackbar
                            open={snackbar.isOpen}
                            onClose={handleCloseSnackbar}
                            message={snackbar.message}
                            severity={snackbar.type}
                        />
                        <AlertDialog
                            handleOpen={isOpenConfirmDialog.open}
                            handleClose={handleCloseConfirmDialog}
                            handleSubmit={handleDialogRegisterSeminar}
                            contents={isOpenConfirmDialog.content}
                            customColor={customColor}
                        />
                        <ConfirmDialog
                            title={intl.formatMessage({ id: 'confirm' })}
                            contents={isOpenConfirmSuccess.content}
                            open={isOpenConfirmSuccess.open}
                            handleClose={handleSuccessDialog}
                            customColor={customColor}
                        />
                    </GridItem>
                </WrapperContainer>
            )}
        </>
    );
}

DetailSeminar.defaultProps = {
    detailSeminarViewer: {},
    idRegister: {},
    registerStatus: false,
    paymentLink: '',
    eventInfo: {},
    detailSeminarRegistered: {},
    registerErrors: {},
    getDetailSeminarFreeLogin: () => {},
    clearRegisteredSeminar: () => {},
    token: '',
    customText: {},
    customColor: {},
    locale: 'ja',
};

DetailSeminar.propTypes = {
    registerSeminarRequested: PropTypes.func.isRequired,
    clearRegisterSeminar: PropTypes.func.isRequired,
    detailSeminarViewer: PropTypes.oneOfType([() => null, PropTypes.array]),
    detailSeminarRegistered: PropTypes.oneOfType([() => null, PropTypes.object]),
    getDetailSeminarViewer: PropTypes.func.isRequired,
    clearDetailSeminarViewer: PropTypes.func.isRequired,
    registerStatus: PropTypes.bool,
    idRegister: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    registerErrors: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLoading: PropTypes.bool.isRequired,
    paymentLink: PropTypes.string,
    getDetailSeminarFreeLogin: PropTypes.func,
    clearRegisteredSeminar: PropTypes.func,
    token: PropTypes.string,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
};

export default DetailSeminar;
